(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sopapets-product-information"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sopapets-product-information')) {
    customElements.define('sopapets-product-information', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.animations = new Map();
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        const options = {signal:this.controller.signal};
        this.querySelectorAll(':scope > details').forEach(details => {
          details.querySelector('summary').addEventListener('click', event => {
            event.preventDefault();
            const opening = details.hasAttribute('data-closing') || !details.open;
            this.togglePanel(details, opening);
          }, options);
        });
        this.description = this.querySelector('.sopa-info__description');
        this.more = this.querySelector('.sopa-info__more');
        if (this.description && this.more) {
          this.more.addEventListener('click', () => this.toggleDescription(), options);
          this.observer = new ResizeObserver(() => this.measureDescription());
          this.observer.observe(this.description);
          this.measureDescription();
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.animations?.forEach(animation => animation.cancel());
        this.descriptionAnimation?.cancel();
      }
      togglePanel(details, opening) {
        const start = details.getBoundingClientRect().height;
        this.animations.get(details)?.cancel();
        details.removeAttribute('data-closing');
        details.open = true;
        details.style.height = '';
        if (opening) this.measureDescription();
        const end = opening ? details.getBoundingClientRect().height : details.querySelector('summary').getBoundingClientRect().height;
        if (!opening) details.setAttribute('data-closing','');
        const finish = () => {
          details.open = opening;
          details.removeAttribute('data-closing');
          details.style.overflow = '';
          this.animations.delete(details);
        };
        if (this.reduced.matches) { finish(); return; }
        details.style.overflow = 'hidden';
        const animation = details.animate({height:[`${start}px`,`${end}px`]}, {duration:300,easing:'cubic-bezier(.22,1,.36,1)'});
        this.animations.set(details, animation);
        animation.onfinish = finish;
      }
      measureDescription() {
        if (!this.description || !this.description.closest('details').open || this.descriptionAnimation) return;
        const limit = parseFloat(getComputedStyle(this).getPropertyValue('--sopa-info-preview')) || 220;
        const overflow = this.description.scrollHeight > limit + 4;
        this.more.hidden = !overflow;
        if (!overflow) this.more.setAttribute('aria-expanded','false');
        this.description.classList.toggle('is-truncated',overflow && this.more.getAttribute('aria-expanded') !== 'true');
      }
      toggleDescription() {
        const opening = this.more.getAttribute('aria-expanded') !== 'true';
        this.descriptionAnimation?.cancel();
        this.descriptionAnimation = null;
        const start = this.description.getBoundingClientRect().height;
        this.more.setAttribute('aria-expanded', String(opening));
        this.more.textContent = opening ? this.more.dataset.less : this.more.dataset.more;
        this.description.classList.toggle('is-truncated', !opening);
        const end = this.description.getBoundingClientRect().height;
        if (this.reduced.matches) return;
        const animation = this.description.animate({maxHeight:[`${start}px`,`${end}px`]}, {duration:300,easing:'ease-out'});
        this.descriptionAnimation = animation;
        this.description.style.overflow = 'hidden';
        animation.onfinish = () => { this.descriptionAnimation = null; this.description.style.overflow = ''; this.measureDescription(); };
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
